/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Search_CarriersInputs */

const en_orders_search_carriers = /** @type {(inputs: Orders_Search_CarriersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search carriers...`)
};

const es_orders_search_carriers = /** @type {(inputs: Orders_Search_CarriersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar transportistas...`)
};

/**
* | output |
* | --- |
* | "Search carriers..." |
*
* @param {Orders_Search_CarriersInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_search_carriers = /** @type {((inputs?: Orders_Search_CarriersInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Search_CarriersInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_search_carriers(inputs)
	return es_orders_search_carriers(inputs)
});